import { store } from 'app/store';
import { fetchUserProfileAcls, fetchUserProfileAclsAndLicenses } from 'common/services/api/UserProfileAcls/UserProfileAcls.thunk';
import { fetchUserProfileClaims } from 'common/services/api/UserProfileClaims/UserProfileClaims.thunk';
import { fetchUserProfileTenant } from 'common/services/api/UserProfileGlobalRoles/UserProfileGlobalRoles.thunk';
import { fetchUserProfileRoles } from 'common/services/api/UserProfileRoles/UserProfileRoles.thunk';
import { fetchUserProfileUserGroups } from 'common/services/api/UserProfileUserGroups/UserProfileUserGroups.thunk';
import { UserDetails } from 'common/types/Entities';

import { IUserProfileTenant } from './UserProfileApps';

export type UserProfileTenantUpdatePayload = {
    tenantId: string,
    userId: string,
    currentUserProfileTenant?: IUserProfileTenant
};

export const getUserProfileTenantUpdatePayload = (
    tenant: IUserProfileTenant | undefined,
    userDetails: UserDetails | null,
): UserProfileTenantUpdatePayload => ({
    tenantId: tenant?.id ?? '',
    userId: userDetails?.userId ?? '',
    currentUserProfileTenant: tenant
});

export const updateUserProfileTenant = (
    payload: UserProfileTenantUpdatePayload
) => {
    const { tenantId, userId, currentUserProfileTenant } = payload;
    const { dispatch } = store;

    dispatch(fetchUserProfileTenant({ tenantId, userId })).catch(console.error);
    dispatch(fetchUserProfileUserGroups({ tenantId, userId })).catch(console.error);
    dispatch(fetchUserProfileRoles({ tenantId, userId })).catch(console.error);
    dispatch(fetchUserProfileClaims({ tenantId, userId })).catch(console.error);
    if (currentUserProfileTenant?.isLicenseRequired) {
        dispatch(fetchUserProfileAclsAndLicenses({ currentUserProfileTenant, userId })).catch(console.error);
    } else {
        dispatch(fetchUserProfileAcls({ tenantId, userId })).catch(console.error);
    }
};
